import AuthService from '../../AuthService';
const FaqCategory = {
  getFaqCategory(page){
    return AuthService.get(`faq/faq_category?page=${page}`);
  },
  showFaqCategory(id){
    return AuthService.get(`faq/faq_category/${id}`);
  },
  createFaqCategory(data){
    return AuthService.post(`faq/faq_category`,data);
  },
  updateFaqCategory(id,data){
    return AuthService.put(`faq/faq_category/${id}`,data);
  },
  deleteFaqCategory(id){
    return AuthService.delete(`faq/faq_category/${id}`);
  },
  getFaqCategoryAll(){
    return AuthService.get(`faq/faq_category_all`);
  }
}
export default FaqCategory
